/* ==========================================================================
   SearcherFlightHotel > Transactions
   ========================================================================== */

const { oneLineTrim } = require('common-tags');

/* Modules */
const axios = module.require('axios');

/* Function */
function getFlightOperative(instance, callback) {
    const xhrCall = new XMLHttpRequest();
    xhrCall.open('GET', getFlightOperativeUrl(instance), true);
    xhrCall.send();
    xhrCall.onreadystatechange = function s() {
        if (xhrCall.readyState === XMLHttpRequest.DONE) {
            if (xhrCall.status === 200) {
                let rs = {};
                if (xhrCall.response !== '') {
                    rs = JSON.parse(xhrCall.response);
                    callback(rs, instance);
                }
            }
        }
    };
}

// TODO: Merge with getFlightOperative() and pass parameter with url
function getApplicableDiscounts(instance, callback) {
    const xhrCall = new XMLHttpRequest();
    xhrCall.open('GET', getApplicableDiscountsUrl(instance), true);
    xhrCall.send();
    xhrCall.onreadystatechange = function s() {
        if (xhrCall.readyState === XMLHttpRequest.DONE) {
            if (xhrCall.status === 200) {
                let rs = {};
                if (xhrCall.response !== '') {
                    rs = JSON.parse(xhrCall.response);
                }
                callback(rs, instance);
            }
        }
    };
}

function getApiFlightOperative(instance) {
    const url = getFlightOperativeUrl(instance);
    return axios.get(url).then(response => getDataFlightOperative(response.data));
}

function getApiDiscount(instance) {
    const url = getApplicableDiscountsUrl(instance);
    return axios.get(url).then(response => response.data);
}

function getDataFlightOperative(data) {
    return {
        checkin: {
            disableDays: data.checkins.filter(item => item.s > 1).map(day => formatDate(day.d)),
            directFlight: data.checkins.filter(item => item.s === 0).map(day => formatDate(day.d))
        },
        checkout: {
            disableDays: data.checkouts.filter(item => item.s > 1).map(day => formatDate(day.d)),
            directFlight: data.checkouts.filter(item => item.s === 0).map(day => formatDate(day.d))
        }
    };
}

function formatDate(date) {
    const d = new Date(date);

    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return `${[year, month, day].join('/')}`;
}

function suscriptionDates(instance) {
    const result = instance;

    getApiFlightOperative(instance)
        .then(data => {
            if (data !== undefined) {
                result.flightOperative = data;
                instance.disableDaysCalendar(instance);
                instance.calendar.element.classList.remove('is-disabled');
            }
        })
        .catch(e => {
            instance.calendar.element.classList.remove('is-disabled');
            console.error('Flight Operative', e);
        });

    getApiDiscount(instance)
        .then(data => {
            result.discounts.dataApi = data;
            result.discounts.data = [];

            result.discounts.setChoices(
                result.discounts.dataApi.map(d => ({ value: d.type, label: d.name })),
                'value',
                'label',
                true
            );
            if (result.discounts.dataApi.length > 1) {
                result.discounts.element.classList.remove('is-hidden');
            }
            if (result.discounts.dataApi.length === 0) {
                result.discounts.value = 0;
                result.discounts.element.classList.add('is-hidden');
            }
        })
        .catch(e => {
            console.error('Discount Operative', e.message);
        });
}

function getFlightOperativeUrl(instance) {
    // TODO: Get values through model or get from config.js
    const flightOperativeUrl = '/packagesalexswc/AjaxServices/GetFlightOperative/';
    return `${flightOperativeUrl}${getFlightOperativeUrlParams(instance)}`;
}

function getApplicableDiscountsUrl(instance) {
    // TODO: Get values through model or get from config.js
    const flightOperativeUrl = '/packagesalexswc/AjaxServices/ApplicableDiscounts';
    return `${flightOperativeUrl}${getApplicableDiscountsUrlParams(instance)}`;
}

function getFlightOperativeUrlParams(instance) {
    const origin = instance.location[0].value || instance.config.location.origin.value;
    const destination = instance.location[1].value || instance.config.location.destination.value;

    let destinationType = 3;
    if (
        instance.location[1].kind === 'ZON' ||
        instance.config.location.destination.type === 'ZON' ||
        instance.location[1].kind === 'ISL' ||
        instance.config.location.destination.type === 'ISL'
    ) {
        destinationType = 2;
    }
    const application = instance.element.getAttribute('data-application');
    return oneLineTrim`?ori=${origin}
        &des_code=${destination}
        &des_type=${destinationType}
        &date_from=
        &date_to=
        &app=${application}
        &stops=0`;
}

function getApplicableDiscountsUrlParams(instance) {
    const origin = instance.location[0].value || instance.config.location.origin.value;
    const destination = instance.location[1].value || instance.config.location.destination.value;
    const destinationType = instance.location[1].kind || instance.config.location.destination.type;
    const lang = instance.element.getAttribute('data-language');
    const application = instance.element.getAttribute('data-application');
    return `?ori=${origin}&dest=${destination}&type=${destinationType}&app=${application}&lang=${lang}`;
}

module.exports = {
    getFlightOperative,
    getApiFlightOperative,
    getApiDiscount,
    suscriptionDates,
    getApplicableDiscounts
};
